import {
  VISUALITZACIO_INICIALITZAR,
  VISUALITZACIO_OMPLIR_DATA_INICI
} from "../../actions/actionTypes";
import { dataActual, MASCARA_ISO_DIA, textAMoment } from "../../utils/dates";

const ESTAT_INICIAL = dataActual().format(MASCARA_ISO_DIA);

const dataInici = (state = ESTAT_INICIAL, action) => {
  switch (action.type) {
    case VISUALITZACIO_INICIALITZAR:
      return ESTAT_INICIAL;

    case VISUALITZACIO_OMPLIR_DATA_INICI:
      return action.payload.format(MASCARA_ISO_DIA);

    default:
      return state;
  }
};

export default dataInici;

export const getDataInici = state => state.dataInici;

export const getDataIniciAsMoment = state =>
  textAMoment(state.dataInici, MASCARA_ISO_DIA);
